import React, { useMemo } from 'react'

import colors from '../../../../../config/colors'
import { Earning } from '../earnings-common/types'
import EstimateBeat from './EstimateBeat'

const QUARTERS_TO_COMPARE = 8

interface Props {
  earningsData: Earning[]
}

export default function EstimateBeats({ earningsData }: Props) {
  const data = useMemo(() => {
    let quarters = 0
    let epsBeats = 0
    let gaapEpsBeats = 0
    let revenueBeats = 0
    for (let idx = earningsData.length - 1; idx > 0; idx--) {
      if (quarters >= QUARTERS_TO_COMPARE) {
        break
      }
      const earning = earningsData[idx]
      if (earning.epsActual !== null || earning.epsReportedActual !== null || earning.salesActual !== null) {
        quarters += 1
        if (earning.epsActual !== null && earning.epsEstimate !== null && earning.epsActual > earning.epsEstimate) {
          epsBeats++
        }
        if (
          earning.epsReportedActual !== null &&
          earning.epsReportedEstimate !== null &&
          earning.epsReportedActual > earning.epsReportedEstimate
        ) {
          gaapEpsBeats++
        }
        if (
          earning.salesActual !== null &&
          earning.salesEstimate !== null &&
          earning.salesActual > earning.salesEstimate
        ) {
          revenueBeats++
        }
      }
    }
    return {
      epsBeats,
      gaapEpsBeats,
      revenueBeats,
      quarters,
    }
  }, [earningsData])

  return (
    <div className="flex justify-evenly text-muted">
      <EstimateBeat color={colors.blue[400]} label="EPS" beats={data.epsBeats} total={data.quarters} />
      <EstimateBeat color={colors.orange[400]} label="GAAP EPS" beats={data.gaapEpsBeats} total={data.quarters} />
      <EstimateBeat color={colors.violet[500]} label="Revenue" beats={data.revenueBeats} total={data.quarters} />
    </div>
  )
}
